import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CharitableGivingOptions } from '../../../../api/useGoalsQuery';
import { CharitableGoalDataDTO } from '../../CharitableGiving.meta';
import { Select } from '../../../../../../CommonComponents/OPL/Select/Select/Select';

interface Props {
  options: CharitableGivingOptions;
}

export const KindOfProperty = ({ options }: Props) => {
  const { control, formState } = useFormContext<CharitableGoalDataDTO>();

  const { kindOfPropertyOptions } = options;

  return (
    <Controller
      control={control}
      name="kindOfProperty"
      render={({ field: { value: formValue, onChange, ref } }) => (
        <Select
          innerRef={ref}
          label="Property"
          value={kindOfPropertyOptions.find(({ value }) => value === formValue)}
          onChange={opt => onChange(opt?.value)}
          options={kindOfPropertyOptions}
          formVariant={formState.errors.kindOfProperty ? 'error' : undefined}
          helperText={formState.errors.kindOfProperty?.message}
        />
      )}
    />
  );
};
